"use strict";

exports.__esModule = true;

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _recompose = require("recompose");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var classBase = "csp-accordion";

var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    var _temp, _this, _ret;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleKeyEvents = function (event) {
      var _this$props = _this.props,
          isOpen = _this$props.isOpen,
          toggleIsOpen = _this$props.toggleIsOpen;


      var code = event.key || event.charCode || event.keyCode;

      //ignore keys if modifiers are active
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
        return;
      }

      switch (code) {
        case "Enter":
        case 13:
        case "Space":
        case " ":
        case 32:
          toggleIsOpen(!isOpen);
          //expand/collapse header
          event.preventDefault();
          break;
        default:
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Accordion.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        children = _props.children,
        isOpen = _props.isOpen,
        toggleIsOpen = _props.toggleIsOpen;


    var panelClass = classBase + "__panel--" + (isOpen ? "expanded" : "collapsed");

    return _react2.default.createElement(
      "div",
      { className: classBase },
      _react2.default.createElement(
        "h3",
        {
          role: "tab",
          className: classBase + "__header",
          "aria-expanded": isOpen,
          onClick: function onClick() {
            return toggleIsOpen(!isOpen);
          },
          onKeyDown: this.handleKeyEvents,
          tabIndex: "0"
        },
        title
      ),
      _react2.default.createElement(
        "section",
        { role: "tabpanel", className: classBase + "__panel " + panelClass, "aria-hidden": !isOpen },
        children
      )
    );
  };

  return Accordion;
}(_react.Component);

Accordion.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.object,
  isOpen: _propTypes2.default.bool,
  toggleIsOpen: _propTypes2.default.func
} : {};

exports.default = (0, _recompose.compose)((0, _recompose.withState)("isOpen", "toggleIsOpen", false))(Accordion);
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/lib/components/accordion/Accordion.js
// module id = 1343
// module chunks = 249